export const userLocalStorage = 'IbnAlNafis_user';
